import { type LucideProps } from 'lucide-react'

/**
 * Hierarchy Level 2 Icon
 *
 * Three stacked chevrons pointing up with the MIDDLE chevron highlighted in silver.
 * Represents the second organizational level (Division).
 *
 * Color: Silver (#C0C0C0) - Second place in medal hierarchy
 */
export function HierarchyLevel2({
  size = 24,
  className = '',
  ...props
}: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      {...props}
    >
      {/* Top chevron - thin muted */}
      <path
        d="M6 10 L12 4 L18 10"
        strokeWidth="1.5"
        stroke="currentColor"
        opacity="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Middle chevron - bold silver (highlighted) */}
      {/* Color matches HIERARCHY_COLORS.silver in hierarchy-utils.ts */}
      <path
        d="M6 15 L12 9 L18 15"
        strokeWidth="2.5"
        stroke="#C0C0C0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Bottom chevron - thin muted */}
      <path
        d="M6 20 L12 14 L18 20"
        strokeWidth="1.5"
        stroke="currentColor"
        opacity="0.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
